import React, { useContext } from 'react'
import styles from './noDataYet.m.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import messages from './noDataYet.locales.yml'
import { LocaleContext } from 'contexts/locale'

/**
 * In case we don't have any rounds yet (election has not started yet), show
 * a replacement message.
 */
export function NoDataYet() {
  const locale = useContext(LocaleContext)
  const localisedMessages = messages[locale]

  return (
    <div className={styles.message}>
      <i className={styles.icon} />
      <div className={styles.content}>
        <div className={styles.header}>{localisedMessages.header}</div>
        <p>{localisedMessages.description}</p>
      </div>
    </div>
  )
}
